import React from 'react';

import { BetaBadge } from 'components/betaBadge';
import StaticLink from 'components/staticLink/StaticLink';
import { ReactComponent as ArrowForward } from 'components/svg/icons/arrow-forward.svg';
import I18n from 'components/translate/I18n';
import { STATIC_LINKS } from 'modules/dashboard/constants';

import './PublishAndNotifyButton.scss';

const PublishAndNotifyButton = () => (
  <>
    <span className="publish-dropdown__item__title _d-flex _align-items-center">
      <p className="publish-dropdown__item__title__label _mt-0">
        <I18n label="content_list.email_notification.dropdown_button_label" />
      </p>
      <BetaBadge />
    </span>
    <div className="publish-dropdown__item__description">
      <I18n label="content_list.email_notification.dropdown_button_description" />{' '}
      <StaticLink links={STATIC_LINKS.PUBLISH_AND_NOTIFY}>
        <I18n label="general.know_more" />
        <ArrowForward className="publish-dropdown__item__description__icon" />
      </StaticLink>
    </div>
  </>
);

export default PublishAndNotifyButton;
